<template lang="html">
	<section class="comp-ctn-docs">
		<custom-select-user v-model="currentClient" :items="clients"/>
		<div class="ctn-missions" v-if="currentClient">
			<div class="mission" v-for="(mission, key) in missionsWithDocuments" v-bind:key="key">
				<div class="mission-name">
					{{ mission.title }}
				</div>
				<div class="ctn-docs row">
					<tile-doc :doc="doc" v-for="(doc, keyt) in mission.documents" v-bind:key="keyt"/>
				</div>
				<div class="no-docs" v-if="mission.documents.length === 0">
					Pas de documents pour le moment
				</div>
			</div>

			<div class="mission" v-if="othersDocs && othersDocs.length > 0">
				<div class="mission-name">
					Autres
				</div>
				<div class="ctn-docs row">
					<tile-doc :doc="doc" v-for="(doc, keyt) in othersDocs" v-bind:key="keyt"/>
				</div>
			</div>

			<div class="no-missions" v-if="missions.length === 0">
				Pas de missions pour le moment
			</div>
		</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import TileDoc from '@/common/components/tile-doc'
import emma from '@/common/services/Emma'
import CustomSelectUser from '@/common/components/Form/CustomSelectUser'

export default {
	name: 'Operations',
	components: {
		CustomSelectUser,
		TileDoc
	},
	data () {
		return {
			currentClient: null,
			docs: [],
			missions: [],
			isLoadingDocs: false,
		}
	},
	methods: {
		fetchDocs() {
			if (!this.currentClient || !this.currentClient.id) return

			this.isLoadingDocs = true
			this.docs = []

			emma.get(`api/documents/operations/${this.currentClient.id}`)
				.then((result) => {
					if (result.data.success) {
						this.docs = result.data.documents
					}
				})
				.catch((error) => {
					console.warn('Erreur lors du fetch des documents :', error)
				})
				.finally(() => {
					this.isLoadingDocs = false
				})
		}
	},
	mounted: function () {
		console.log('this.clients', this.client);
		if (this.clients.length > 0) {
			this.currentClient = this.clients[0]
		} 
	},
	watch: {
		clients(newVal) {
			if (newVal && newVal.length > 0 && !this.currentClient) {
				this.currentClient = newVal[0]
			}
		},
		currentClient(newClient, oldClient) {
			if (!newClient || !newClient.id) return
			if (oldClient && oldClient.id === newClient.id) return

			this.$store.dispatch('getClient', newClient.id).then(() => {
				const client = this.clients.find(c => c.id === newClient.id)
				this.missions = client ? client.missions : []
			})
			this.fetchDocs()
		}
	},
	computed: {
		...mapGetters({
			clients: 'getClients',
		}),

		othersDocs () {
			return this.docs.filter((item) => !item.sub_category || item.sub_category === 'null')
		},
		missionsWithDocuments () {
			return this.missions.filter((mission) => mission.documents && mission.documents.length > 0)
		}
	}
}
</script>

<style lang="scss" scoped>
.no-docs {
	margin: 0.5rem;
	font-size: 0.8rem;
	opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// Operations.vue?06861653